module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/operations.54e0d4ac.svg";